<template>
  <v-select
    :label="displayText"
    :items="roleList"
    v-model="securityRolesValue"
    :multiple="multiple"
    :chips="multiple"
    item-text="label"
    item-value="name"
    :clearable="clearable"
    :rules="[requiredCheck()]"
    outlined
  ></v-select>
</template>

<script>
import { allRolesList, SUPER_ADMIN } from '@/lib/constants/securityRoles'
import { required } from '@/lib/formValidations'
import { userIsSuperAdmin } from '@/lib/authentication'

export default {
  props: [
    'securityRoles',
    'multiple',
    'isRequired',
    'clearable'
  ],
  data () {
    return {
      allRolesList
    }
  },
  computed: {
    roleList () {
      if (userIsSuperAdmin()) {
        return allRolesList
      }

      return allRolesList.filter(r => r.name !== SUPER_ADMIN.name)
    },
    displayText () {
      return this.multiple ? 'Security Roles' : 'Security Role'
    },
    securityRolesValue: {
      get () {
        return this.securityRoles
      },
      set (newValue) {
        this.$emit('securityRolesChange', newValue)
      }
    }
  },
  methods: {
    requiredCheck () {
      return !this.isRequired || required(this.displayText)
    }
  }
}
</script>
<style >
.v-select.v-select--chips .v-select__selections {
    min-height: 0px !important;
}
.v-chip {
    height: 18px !important;
}
</style>
